import {CheckBox} from "devextreme-react/check-box";
import {DateBox} from "devextreme-react/date-box";
import {useContext} from 'react';
import {Field} from '../../../../layouts';
import {OrderStatus} from '../../../../types/enums';
import {RetailOrderContext} from '../context/RetailOrderContext';

export default function CabinetDate() {

	const { order, modifyOrder } = useContext(RetailOrderContext);
	const readonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled;

	return (
		<>
			<Field label={'Cabinet Purchased'} >
				<CheckBox elementAttr={{ 'data-testid': 'chb-cabinet-purchased' }}
					value={order.details.cabinetFlag}
					readOnly={readonly}
					onValueChanged={(e) => modifyOrder({ ...order.details, cabinetFlag: e.value })} />
			</Field>
			<Field label={'Cabinet Install Date'} visible={order.details.cabinetFlag}>
				<DateBox inputAttr={{ 'data-testid': 'dtb-cabinet-install-date' }}
					value={order.details.cabinetDate}
					readOnly={readonly}
					onValueChanged={(e) => {
						modifyOrder({ ...order.details, cabinetDate: e.value })
					}} />
			</Field>
			<Field label={'PSI Project'} visible={order.details.cabinetFlag}>
				<CheckBox value={order.details.psiProject}
					readOnly={readonly}
					onValueChanged={(e) => modifyOrder({ ...order.details, psiProject: e.value })} />
			</Field>
		</>
	);
}
